import { Component, Input } from '@angular/core';

import { IPrimaryTableCellConfig } from './entity-table-cell.types';

@Component({
  selector: 'entity-table-cell',
  templateUrl: './entity-table-cell.component.html',
  styleUrls: ['./entity-table-cell.component.scss'],
})
export class EntityTableCellComponent {
  /** config for the first line */
  @Input() public primaryConfig!: IPrimaryTableCellConfig;
  /** second‐line inputs */
  @Input() public secondary?: string;
  @Input() public tertiary?: string;
  /** global inputs */
  @Input() public placeholder = '—';
  @Input() public unidentified = false;
  @Input() public unidentifiedText = $localize`Unidentified`;

  public get primaryDisplay(): string {
    const raw = this.primaryConfig.text?.trim() ?? '';
    return raw || this.placeholder;
  }

  public get hasPrimaryText(): boolean {
    return !!this.primaryConfig.text || !!this.primaryConfig.entity;
  }

  public get hasSecondaryRow(): boolean {
    return this.secondary !== undefined || this.tertiary !== undefined;
  }

  public get secondaryTooltip(): string {
    const parts: string[] = [];
    if (this.secondary !== undefined) parts.push(this.secondary || this.placeholder);
    if (this.tertiary !== undefined) parts.push(this.tertiary || this.placeholder);
    return parts.join(' · ');
  }
}
